import { resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_AccountableAccountVue = _resolveComponent("AccountableAccountVue")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_company_table = _resolveComponent("company-table")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card_title, { class: "title font-weight-regular justify-space-between d-flex" }, {
      default: _withCtx(() => [
        _cache[8] || (_cache[8] = _createTextVNode(" Êtes-vous sûr(e) de ne pas avoir la facture ? ")),
        (_ctx.step)
          ? (_openBlock(), _createBlock(_component_v_avatar, {
              key: 0,
              color: "primary lighten-2",
              class: "subheading white--text",
              size: "24",
              textContent: _toDisplayString(_ctx.step)
            }, null, 8, ["textContent"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_card_text, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_form, {
          modelValue: _ctx.withoutInvoiceValid,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.withoutInvoiceValid) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                (_ctx.isAccountingUser && _ctx.bankTransaction)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: _ctx.withoutInvoiceTitle,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.withoutInvoiceTitle) = $event)),
                          label: "Libellé",
                          rules: [(t) => !!t || 'Libellé requis'],
                          density: "compact"
                        }, null, 8, ["modelValue", "rules"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_AccountableAccountVue, {
                      showLabel: true,
                      showValidation: false,
                      companyId: _ctx.companyId,
                      thirdPartyCompanyId: _ctx.thirdPartyCompanyId,
                      inAccountableAccountType: 'SelectedTypes',
                      inAccountableAccountTypes: ['Purchase', 'Sales'],
                      inAccountableAccount: _ctx.accountableAccount,
                      inputStyle: 'padding: 0',
                      hideDetails: "",
                      onSelectAccountableAccount: _ctx.selectAccountableAccount,
                      filled: true
                    }, null, 8, ["companyId", "thirdPartyCompanyId", "inAccountableAccount", "onSelectAccountableAccount"]), [
                      [_vShow, true]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      readonly: "",
                      label: "Société tiers",
                      "hide-details": "",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogSelectCompany = !_ctx.dialogSelectCompany)),
                      rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                      class: "mt-3",
                      disabled: !_ctx.accountableAccount,
                      "model-value": 
                                _ctx.thirdPartyCompany && _ctx.thirdPartyCompany.name
                                    ? _ctx.thirdPartyCompany.name
                                    : ''
                            ,
                      density: "compact"
                    }, null, 8, ["rules", "disabled", "model-value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    (_ctx.showVAT)
                      ? (_openBlock(), _createBlock(_component_v_select_filled, {
                          key: 0,
                          modelValue: _ctx.vatRate,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vatRate) = $event)),
                          items: _ctx.vatList,
                          "hide-details": true,
                          label: "Taux de TVA",
                          class: "mt-3",
                          density: "compact",
                          "item-title": "text"
                        }, null, 8, ["modelValue", "items"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    (_ctx.vatRate !== -1 && _ctx.bankTransaction)
                      ? (_openBlock(), _createBlock(_component_oss_text_field, {
                          key: 0,
                          outlined: "",
                          dense: "",
                          "content-class": "mt-3 oss-",
                          label: "Montant HT",
                          "onUpdate:modelValue": [
                            _ctx.onWithoutInvoiceNetAmountChanged,
                            _cache[3] || (_cache[3] = ($event: any) => ((_ctx.withoutInvoiceNetAmount) = $event))
                          ],
                          rules: _ctx.withoutInvoiceNetAmountRules,
                          modelValue: _ctx.withoutInvoiceNetAmount
                        }, null, 8, ["onUpdate:modelValue", "rules", "modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    (_ctx.vatRate !== -1 && _ctx.bankTransaction)
                      ? (_openBlock(), _createBlock(_component_oss_text_field, {
                          key: 0,
                          outlined: "",
                          dense: "",
                          "content-class": "mt-3 ml-3 oss-",
                          label: "Montant TVA",
                          "onUpdate:modelValue": [
                            _ctx.onWithoutInvoiceVatAmountChanged,
                            _cache[4] || (_cache[4] = ($event: any) => ((_ctx.withoutInvoiceVatAmount) = $event))
                          ],
                          rules: _ctx.withoutInvoiceVatAmountRules,
                          modelValue: _ctx.withoutInvoiceVatAmount
                        }, null, 8, ["onUpdate:modelValue", "rules", "modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    (!_ctx.actions)
      ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              rounded: "",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cancel())),
              style: {"margin":"center"},
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.step ? "Précédent" : "Annuler"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              rounded: "",
              onClick: _ctx.withoutInvoice,
              loading: _ctx.loading,
              disabled: !_ctx.withoutInvoiceValid,
              size: "small"
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("Oui, je suis sûr(e)")
              ])),
              _: 1
            }, 8, ["onClick", "loading", "disabled"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.dialogSelectCompany)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 1,
          modelValue: _ctx.dialogSelectCompany,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialogSelectCompany) = $event)),
          title: 'Choisissez la société tiers',
          width: "800px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_company_table, {
              showGenericCompany: _ctx.accountableAccount && _ctx.accountableAccount.name.startsWith('6'),
              showSupplierCompanies: 
                    _ctx.accountableAccount && _ctx.accountableAccount.name.startsWith('6')
                ,
              showConsumerCompany: _ctx.accountableAccount && _ctx.accountableAccount.name.startsWith('7'),
              showCustomerCompanies: 
                    _ctx.accountableAccount && _ctx.accountableAccount.name.startsWith('7')
                ,
              showExistingCompanies: false,
              showNewCompanies: true,
              parentCompanyId: _ctx.companyId,
              company: _ctx.thirdPartyCompany ? _ctx.thirdPartyCompany.name : '',
              wizardMode: true,
              onSelectCompany: _ctx.companySelected
            }, null, 8, ["showGenericCompany", "showSupplierCompanies", "showConsumerCompany", "showCustomerCompanies", "parentCompanyId", "company", "onSelectCompany"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}